import React, {Component} from 'react'
import propTypes from 'prop-types'
import {AsyncSelectField, SelectField} from 'components/selectField'
import {api} from 'services/api'
import {orderBy, isNil} from 'lodash'
import './purchaseOrderSelectField.scss'
import {getPurchaseOrderOption} from 'helpers/purchasing/purchaseOrders'

class PurchaseOrderSelectField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      purchaseOrders: null,
    }
    this.selectRef = React.createRef()
  }

  focus = () => {
    if (this.selectRef.current)
      this.selectRef.current.focus()
  }

  componentDidMount() {
    const {companyId} = this.props
    if (!isNil(companyId)) this.setWithCompany(companyId)
  }

  componentDidUpdate(prevProps) {
    const {companyId} = this.props
    if (!isNil(companyId)) {
      if (isNil(prevProps.companyId) || prevProps.companyId !== companyId)
        this.setWithCompany(companyId)

    } else if (!isNil(prevProps.companyId)) {
      this.setWithCompany(null)
    }
  }

  setWithCompany = (companyId) => {
    const {params} = this.props
    if (companyId) {
      this.setState({purchaseOrders: []})
      api.purchaseOrder.get({companyId, ...params}, this.getFields()).then(response => {
        api.handleResponseNonYield(
            response,
            (key, data) => {
              this.setState({purchaseOrders: data.result || []})
            },
            (key, message) => {
              console.error('Failed to load purchase orders for company', message)
            }
        )
      })
    } else {
      this.setState({orders: null})
    }
  }

  getFields = () => {
    const {fields} = this.props
    return {
      reference: true,
      description: true,
      status: true,
      ...fields,
    }
  }

  sortOrders = (options = []) => {
    return orderBy(options, ['purchaseOrder.status'])
  }

  getOptions = (purchaseOrders) => {
    const mappedPurchaseOrders = purchaseOrders.map(getPurchaseOrderOption)
    return this.sortOrders(mappedPurchaseOrders)
  }

  render() {
    const {params, ...otherProps} = this.props
    const {purchaseOrders} = this.state
    delete otherProps.fields

    if (purchaseOrders) {
      return <SelectField
          ref={this.selectRef}
          placeholder={'Find a Purchase Order'}
          options={this.getOptions(purchaseOrders)}
          {...otherProps} />
    } else {
      return <AsyncSelectField
          ref={this.selectRef}
          placeholder={'Find a Purchase Order'}
          params={params}
          fields={this.getFields()}
          onLoad={api.purchaseOrder.get}
          onOptions={this.getOptions}
          {...otherProps} />
    }
  }
}

PurchaseOrderSelectField.propTypes = {
  fields: propTypes.object,
  params: propTypes.object,
  companyId: propTypes.number,
}

PurchaseOrderSelectField.defaultProps = {
  params: {
    sortColumn: 'ref',
    sortDirection: 'asc',
  },
}

export default PurchaseOrderSelectField
